import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { RouterAction, withSkipUnsavedChangesConfirmation } from '@cbridge-packages/routing';
import { DetailsSidebarAction } from '../detailsSidebar.action';
import { SidebarOpenMode } from '../detailsSidebar.interface';
import { detailsSidebarStoreSelector } from '../detailsSidebar.selector';

type IState =
  & IGetSelectorStateType<typeof detailsSidebarStoreSelector>;

export const closeEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(DetailsSidebarAction.close),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { id, mode } = detailsSidebarStoreSelector(state);

    if (id !== undefined && (mode === SidebarOpenMode.View || mode === SidebarOpenMode.Edit)) {
      const skipUnsavedChangesConfirmation = payload ? payload.skipUnsavedChangesConfirmation : false;

      return [
        RouterAction.removeLastPathParam(
          skipUnsavedChangesConfirmation ? { locationState: withSkipUnsavedChangesConfirmation() } : {},
        ),
      ];
    }

    return [
      RouterAction.clearLocationState(),
      DetailsSidebarAction.destroy(),
    ];
  }),
);
